import R from 'ramda';
import React from 'react';
import update from 'react/lib/update';
import {
  FilledButton, Exit, ActivateDialog, DeactivateDialog, DeleteDialog,
  UploadErrorDialog, ImageLimitErrorDialog, FileTypeErrorDialog,
} from '../app/components';
import { connect } from 'react-redux';
import { fields } from '../../common/lib/redux-fields';
import { updatePropertyWithImages, deletePropertyWithImages } from '../../common/properties/actions';
import {
  onSelectType, onIncreaseBedrooms, onDecreaseBedrooms, formatDate,
  onFromDateChange, onToDateChange, onSelectProsCons, onImageChange,
  onDeselectImage, handleDeleteDialogOpen, handleDeactivateDialogOpen,
  handleActivateDialogOpen, onSelectContactInfo, assignRef,
} from '../../common/properties/formFunctions';
import './styles.css';
import ZipStep from '../steps/ZipStep/ZipStep';
import TypeStep from '../steps/TypeStep/TypeStep';
import SizeStep from '../steps/SizeStep/SizeStep';
import DateStep from '../steps/DateStep/DateStep';
import PriceStep from '../steps/PriceStep/PriceStep';
import InsuranceStep from '../steps/InsuranceStep/InsuranceStep';
import ProsConsStep from '../steps/ProsConsStep/ProsConsStep';
import ImagesStep from '../steps/ImagesStep/ImagesStep';
import DescriptionStep from '../steps/DescriptionStep/DescriptionStep';
import TitleStep from '../steps/TitleStep/TitleStep';
import ContactStep from '../steps/ContactStep/ContactStep';

let loadImage = null;
let exif = null;

class PropertyEdit extends React.Component {
  constructor(props) {
    super(props);
    const { fields } = this.props;

    fields.$setValue('contactEmail', false);
    fields.$setValue('contactPhonenumber', false);
    this.state = {
      fetchingDataDone: false,
      imageFiles: [],
      imagePreviewUrls: [],
      uploadImageError: false,
      confirmDelete: false,
      confirmDeactivate: false,
      confirmActivate: false,
      imageLimitExceeded: false,
      fileTypeError: false,
      numberOfImages: 0,
    };
  }

  componentWillMount = () => {
    loadImage = require('blueimp-load-image');
    exif = require('exif-js');
  }

  componentDidUpdate = () => {
    const { propertyDetails } = this.props;
    const { fetchingDataDone } = this.state;

    if (propertyDetails !== undefined && !fetchingDataDone) {
      this.setState({
        fetchingDataDone: true,
      }, this.setFieldsVariable);
    }
  }

  onMoveImage = (id, atIndex) => {
    const { imagePreviewUrl, imageFile, index } = this.findImage(id);
    this.setState(update(this.state, {
      imagePreviewUrls: {
        $splice: [
          [index, 1],
          [atIndex, 0, imagePreviewUrl],
        ],
      },
      imageFiles: {
        $splice: [
          [index, 1],
          [atIndex, 0, imageFile],
        ],
      },
    }));
  }

  setFieldsVariable = () => {
    const { fields, viewer, propertyDetails } = this.props;

    fields.$setValue('type', propertyDetails.type);
    fields.$setValue('zip', propertyDetails.zip.toString());
    fields.$setValue('bedrooms', propertyDetails.bedrooms);
    fields.$setValue('size', propertyDetails.size.toString());
    fields.$setValue('title', propertyDetails.title);
    fields.$setValue('availableFrom', propertyDetails.availableFrom);
    fields.$setValue('availableTo', propertyDetails.availableTo);
    fields.$setValue('rentTimeType', propertyDetails.availableTo !== '' ? 'Skammtímaleiga' : 'Langtímaleiga');
    fields.$setValue('price', propertyDetails.price.toString());
    fields.$setValue('insuranceAmount', propertyDetails.insuranceAmount.toString());
    fields.$setValue('insuranceType', propertyDetails.insuranceType);
    fields.$setValue('bathIncluded', propertyDetails.bathIncluded);
    fields.$setValue('dishwasherIncluded', propertyDetails.dishwasherIncluded);
    fields.$setValue('electricityIncluded', propertyDetails.electricityIncluded);
    fields.$setValue('fridgeIncluded', propertyDetails.fridgeIncluded);
    fields.$setValue('furnitureIncluded', propertyDetails.furnitureIncluded);
    fields.$setValue('heatIncluded', propertyDetails.heatIncluded);
    fields.$setValue('petsAllowed', propertyDetails.petsAllowed);
    fields.$setValue('showerIncluded', propertyDetails.showerIncluded);
    fields.$setValue('smokingAllowed', propertyDetails.smokingAllowed);
    fields.$setValue('stoveIncluded', propertyDetails.stoveIncluded);
    fields.$setValue('washingMachineIncluded', propertyDetails.washingMachineIncluded);
    fields.$setValue('dryingMachineIncluded', propertyDetails.dryingMachineIncluded);
    fields.$setValue('description', propertyDetails.description);
    fields.$setValue('contactFacebook', propertyDetails.contactFacebook !== '');
    fields.$setValue('contactEmail', propertyDetails.contactEmail !== '');
    fields.$setValue('contactPhonenumber', propertyDetails.contactPhonenumber !== '');
    fields.$setValue('contactEmailValue', propertyDetails.contactEmail || viewer.email || '');
    fields.$setValue('contactPhonenumberValue', propertyDetails.contactPhonenumber);
  }

  setNumberOfImages = (number, cb) => {
    this.setState({ numberOfImages: number }, cb);
  }

  findImage = (id) => {
    const { imagePreviewUrls, imageFiles } = this.state;
    const imagePreviewUrl = imagePreviewUrls.filter(imagePreviewUrl =>
      imagePreviewUrl.key === id)[0];
    const imageFile = imageFiles.filter(imageFile =>
      imageFile.key === id)[0];
    return {
      imagePreviewUrl,
      imageFile,
      index: imagePreviewUrls.indexOf(imagePreviewUrl),
    };
  }

  confirmChanges = (e) => {
    const { fields, viewer, propertyDetails, updatePropertyWithImages } = this.props;
    const { imageFiles } = this.state;
    e.preventDefault();

    const updatedProperty = {
      id: propertyDetails.id,
      zip: parseInt(fields.zip.value, 10),
      type: fields.type.value.trim(),
      title: fields.title.value.trim(),
      description: fields.description.value.trim(),
      insuranceType: fields.insuranceType.value.trim(),
      insuranceAmount: parseInt(fields.insuranceAmount.value.replace(/\./g, ''), 10),
      bedrooms: parseInt(fields.bedrooms.value, 10),
      price: parseInt(fields.price.value.replace(/\./g, ''), 10),
      size: parseInt(fields.size.value.replace(/\./g, ''), 10),
      bathIncluded: fields.bathIncluded.value,
      dishwasherIncluded: fields.dishwasherIncluded.value,
      electricityIncluded: fields.electricityIncluded.value,
      fridgeIncluded: fields.fridgeIncluded.value,
      furnitureIncluded: fields.furnitureIncluded.value,
      heatIncluded: fields.heatIncluded.value,
      petsAllowed: fields.petsAllowed.value,
      showerIncluded: fields.showerIncluded.value,
      smokingAllowed: fields.smokingAllowed.value,
      stoveIncluded: fields.stoveIncluded.value,
      washingMachineIncluded: fields.washingMachineIncluded.value,
      dryingMachineIncluded: fields.dryingMachineIncluded.value,
      availableFrom: fields.availableFrom.value.trim(),
      availableTo: fields.rentTimeType.value === 'Langtímaleiga' ? '' : fields.availableTo.value.trim(),
      contactFacebook: fields.contactFacebook.value ? viewer.facebookId : '',
      contactEmail: fields.contactEmail.value ? fields.contactEmailValue.value.trim() : '',
      contactPhonenumber: fields.contactPhonenumber.value ? fields.contactPhonenumberValue.value.trim() : '',
      imageDownloadUrls: propertyDetails.imageDownloadUrls,
    };

    updatePropertyWithImages(updatedProperty, imageFiles);
  }

  validate = () => {
    const { fields } = this.props;

    if (fields.zip.value.length === 3 &&
      fields.type.value !== '' &&
      fields.bedrooms.value >= 0 &&
      fields.size.value !== '' && fields.size.value >= 0 &&
      fields.price.value !== '' && fields.price.value >= 0 &&
      fields.insuranceAmount.value !== '' && fields.insuranceAmount.value >= 0 &&
      fields.insuranceType.value !== '' &&
      fields.description.value !== '' &&
      fields.title.value !== '' &&
      (fields.contactEmail.value || fields.contactPhonenumber.value ||
        fields.contactFacebook.value) &&
      (!fields.contactEmail.value || fields.contactEmailValue.value !== '') &&
      (!fields.contactPhonenumber.value || fields.contactPhonenumberValue.value.length === 7)) {
      return true;
    }

    return false;
  }

  render() {
    const {
      propertyDetails, fields, updatePropertyWithImages,
      deletePropertyWithImages, location,
    } = this.props;
    const {
      imageFiles, imagePreviewUrls, uploadImageError, confirmDelete, numberOfImages,
      confirmDeactivate, confirmActivate, imageLimitExceeded, fileTypeError,
    } = this.state;

    return (
      <form className="property-edit">
        <ActivateDialog
          component={this}
          propertyId={propertyDetails.id}
          confirmActivate={confirmActivate}
          updatePropertyWithImages={updatePropertyWithImages}
        />
        <DeactivateDialog
          component={this}
          propertyId={propertyDetails.id}
          confirmDeactivate={confirmDeactivate}
          updatePropertyWithImages={updatePropertyWithImages}
        />
        <DeleteDialog
          component={this}
          propertyId={propertyDetails.id}
          numberOfImages={propertyDetails.imageDownloadUrls.length}
          confirmDelete={confirmDelete}
          deletePropertyWithImages={deletePropertyWithImages}
        />
        <UploadErrorDialog
          component={this}
          uploadImageError={uploadImageError}
        />
        <ImageLimitErrorDialog
          component={this}
          imageLimitExceeded={imageLimitExceeded}
        />
        <FileTypeErrorDialog
          component={this}
          fileTypeError={fileTypeError}
        />
        <div className="header-wrapper">
          <Exit
            location={location}
            to={location.state ? location.state.from : '/'}
            color="#222222"
            requireConfirm
          />
          <FilledButton
            className="no-icon"
            content={<p>Vista breytingar</p>}
            disabled={!this.validate()}
            color="#222222"
            backgroundColor="#00e39a"
            onClick={this.confirmChanges}
          />
        </div>
        <div className="steps">
          <ImagesStep
            imagePreviewUrls={imagePreviewUrls}
            onImageChange={(e) => {
              e.persist();
              const numberOfImages = imagePreviewUrls.length + e.target.files.length;
              this.setNumberOfImages(numberOfImages, () => {
                onImageChange(e, loadImage, exif, this, imageFiles, imagePreviewUrls,
                  propertyDetails.imageDownloadUrls.length);
              });
            }}
            onDeselectImage={(e, key) => {
              e.persist();
              this.setNumberOfImages((numberOfImages - 1), () => {
                onDeselectImage(e, this, key, imageFiles, imagePreviewUrls);
              });
            }}
            onMoveImage={this.onMoveImage}
            findImage={this.findImage}
            uploadingFiles={numberOfImages !== imagePreviewUrls.length}
          />
          <ZipStep fields={fields} />
          <TitleStep fields={fields} />
          <TypeStep fields={fields} onSelectType={onSelectType} />
          <SizeStep
            fields={fields} onIncreaseBedrooms={onIncreaseBedrooms}
            onDecreaseBedrooms={onDecreaseBedrooms}
          />
          <DescriptionStep fields={fields} />
          <DateStep
            fields={fields} formatDate={formatDate} onFromDateChange={onFromDateChange}
            onToDateChange={onToDateChange}
          />
          <PriceStep fields={fields} />
          <InsuranceStep fields={fields} />
          <ProsConsStep fields={fields} onSelectProsCons={onSelectProsCons} />
          <ContactStep
            fields={fields}
            assignRef={(field, c) => assignRef(this, field, c)}
            onSelectContactInfo={
              (isInputChecked, input) =>
                onSelectContactInfo(this, fields, isInputChecked, input)
            }
          />
          <div className="action-buttons">
            <FilledButton
              className="no-icon"
              content={<p>Vista breytingar</p>}
              disabled={!this.validate()}
              color="#222222"
              backgroundColor="#00e39a"
              onClick={this.confirmChanges}
            />
            <FilledButton
              className="no-icon"
              content={propertyDetails.active ?
                <p>Óvirkja auglýsingu</p> :
                <p>Virkja auglýsingu</p>
              }
              disabled={false}
              flat
              color={propertyDetails.active ? '#FBAD36' : '#00e39a'}
              backgroundColor="#ffffff"
              onClick={propertyDetails.active ?
                e => handleDeactivateDialogOpen(e, this) :
                e => handleActivateDialogOpen(e, this)
              }
            />
            <FilledButton
              className="no-icon"
              content={<p>Eyða auglýsingu</p>}
              disabled={false}
              flat
              color="#f53957"
              backgroundColor="#ffffff"
              onClick={e => handleDeleteDialogOpen(e, this)}
            />
          </div>
        </div>
      </form>
    );
  }
}

PropertyEdit.propTypes = {
  location: React.PropTypes.any,
  fields: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object,
  propertyDetails: React.PropTypes.object.isRequired,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
  deletePropertyWithImages: React.PropTypes.func.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
    }),
    { updatePropertyWithImages, deletePropertyWithImages },
  ),
  fields({
    path: 'editProperty',
    fields: [
      'zip',
      'type',
      'title',
      'bedrooms',
      'size',
      'availableFrom',
      'availableTo',
      'rentTimeType',
      'price',
      'insuranceAmount',
      'insuranceType',
      'bathIncluded',
      'dishwasherIncluded',
      'electricityIncluded',
      'fridgeIncluded',
      'furnitureIncluded',
      'heatIncluded',
      'petsAllowed',
      'showerIncluded',
      'smokingAllowed',
      'stoveIncluded',
      'washingMachineIncluded',
      'dryingMachineIncluded',
      'description',
      'contactFacebook',
      'contactEmail',
      'contactPhonenumber',
      'contactEmailValue',
      'contactPhonenumberValue',
    ],
  }),
)(PropertyEdit);



// WEBPACK FOOTER //
// ./src/browser/propertyEdit/PropertyEdit.js